module.exports = __webpack_public_path__ + "static/fonts/SCDream8.d8ebcaf.otf";